import { getContext } from 'configs/context';

class Analytics {
  private current = '';

  constructor() {
    this.sendEvent = this.sendEvent.bind(this);
  }

  sendEvent(eventAction: string, data: object = {}) {
    getContext()
      .handlers.sendAnalytics({
        eventName: eventAction,
        params: { ...data },
      })
      .catch(err => {
        console.error('Send Analytics Error:', err);
      });
  }

  public get page() {
    return this.current;
  }

  public set page(newPage: string) {
    this.current = newPage;
  }
}

export default new Analytics();
